import Link from "next/link";
import type { ComponentProps, ReactNode } from "react";
import { Spinner } from "./Spinner";

type Variant = "primary" | "outline" | "ghost";

const base =
  "ui-label inline-flex items-center justify-center rounded-pill px-7 py-3.5 " +
  "transition-colors duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed";

const variants: Record<Variant, string> = {
  // Signature booking pill — coffee/accent fill, cream text.
  primary: "bg-ink text-ink-on-dark hover:bg-accent",
  outline: "border border-ink/30 text-ink hover:border-ink hover:bg-ink/5",
  ghost: "text-ink hover:bg-ink/5",
};

export function Button({
  variant = "primary",
  className = "",
  loading = false,
  children,
  disabled,
  ...rest
}: { variant?: Variant; loading?: boolean; children: ReactNode } & ComponentProps<"button">) {
  return (
    <button className={`${base} ${variants[variant]} ${className}`} disabled={disabled || loading} {...rest}>
      {loading && <Spinner size={15} className="mr-2.5 -ml-1" />}
      {children}
    </button>
  );
}

export function ButtonLink({
  variant = "primary",
  className = "",
  children,
  href,
}: {
  variant?: Variant;
  className?: string;
  children: ReactNode;
  href: string;
}) {
  return (
    <Link href={href} className={`${base} ${variants[variant]} ${className}`}>
      {children}
    </Link>
  );
}
